import WideContent from 'core/layout/content/wide-content';
import Link from 'ui/atoms/link';
import styled, { css } from 'styled-components';
import { query } from 'ui/styles/queries';
import { resolveColor } from 'ui/styles/utils/colors';

export const Main = styled.main`
  padding: 1rem 8rem;
  position: relative;
  flex: 1;
  ${query.phoneTablet`
    padding-top: 1rem !important;
  `}
`;

export const Footer = styled.div`
  height: 87px;
  width: 100%;
  bottom: 0px;
  z-index: 1000;
  background-color: ${({ theme }) => resolveColor(theme, 'background')};
  padding: 0rem 9rem;
  display: flex;
  align-items: center;
`;

export const FooterLink = styled(Link)`
  ${({ theme }) => {
    return css`
      color: ${resolveColor(theme, 'white')};
      font-weight: normal;
    `;
  }}
`;

export const FooterWideContent = styled(WideContent)`
  display: flex;
  align-items: center;
`;

export const LinkContainer = styled.div`
  display: flex;
`;

export const Container = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;
